// Libraries
import { Box, chakra, Flex } from "@chakra-ui/react";
import { NextSeo } from "next-seo";
import React, { Fragment, ReactNode } from "react";
// Recoil
import { useRecoilValue } from "recoil";
import { authData } from "../State";
// Components
// import UserNavbar from "./Navbar/UserNavbar";
import Navbar from "./UI/Navbar";
import BottomNav from "./UI/Navbar/BottomNav";

interface layoutProps {
  title: string;
  customNavbar?: ReactNode;
  left: ReactNode;
  right: ReactNode;
  main: ReactNode;
  customLeftWidth?: any;
  customMainWidth?: any;
  customRightWidth?: any;
  rightDisplay?: any;
  mainDisplay?: any;
  leftDisplay?: any;
  noTopNavBar?: boolean;
  description?: string;
  //applyTopMargin is used to add margin to the top of main body for medium screens and above
  applyTopMargin?: boolean;
}

const UserLayoutV2 = ({
  title,
  left,
  right,
  main,
  customNavbar,
  customLeftWidth = "20%",
  customMainWidth = { base: "100%", lg: "50%" },
  customRightWidth = { base: "100%", lg: "30%" },
  leftDisplay = { base: "none", lg: "block" },
  rightDisplay,
  mainDisplay,
  noTopNavBar,
  description,
  applyTopMargin = true,
}: layoutProps) => {
  const { loggedIn } = useRecoilValue(authData);

  const layoutHeight = loggedIn ? { base: "100%", lg: "100vh" } : "100vh";

  if (typeof window !== "undefined") {
    return (
      <Fragment>
        <NextSeo title={title} description={description} canonical="https://learntific.com" />

        {!noTopNavBar && (
          <Box
            // When logged in, navbar is always shown
            // when logged out, navbar is not shown on desktop screens but only on mobile screen
            pos="sticky"
            top={0}
            zIndex={1000}
            d={loggedIn ? { base: "block", lg: "none" } : "block"}>
            <Navbar />
          </Box>
        )}

        {/* <Box overflowY="hidden" mt={!loggedIn ? { base: "60px", md: "80px" } : 0}> */}
        <chakra.section overflow="hidden">
          <Flex height={layoutHeight} pos="relative" flexDir={{ base: "column", lg: "row" }} w="100%">
            {/* Left */}
            <Box
              d={leftDisplay}
              pos="fixed"
              w={customLeftWidth}
              overflowY={{ base: "hidden", lg: "auto" }}
              h="100%"
              borderRightWidth="1px"
              order={1}>
              {left}
            </Box>

            {/* Main */}
            <Flex
              order={{ base: 3, lg: 2 }}
              // overflowY={loggedIn ? "auto" : "hidden"}
              overflowY={{ md: "auto" }}
              // overflowX="hidden"
              w={customMainWidth}
              ml={{ base: "0", lg: "20%" }}
              pos="relative"
              pb={{ base: 10, lg: 0 }}
              d={mainDisplay}
              flexDir="column">
              {/* Custom Navbar */}

              {loggedIn && (
                <Box pos="fixed" bg="white" w={customMainWidth} top={0} zIndex={2222}>
                  {/* {!!customNavbar ? customNavbar : <UserNavbar />} */}
                  {customNavbar}
                </Box>
              )}

              {/* Main content */}

              <Box w="100%">{main}</Box>
            </Flex>

            {/* Right */}
            <Box
              order={{ base: 2, lg: 3 }}
              height={{ base: "auto", lg: "100vh" }}
              w={customRightWidth}
              d={rightDisplay}
              borderLeftWidth="1px"
              overflowX="hidden"
              overflowY={{ base: "hidden", lg: "auto" }}>
              {right}
            </Box>
          </Flex>
        </chakra.section>
        {/* </Box> */}

        <BottomNav />
      </Fragment>
    );
  } else {
    return <></>;
  }
};

export default UserLayoutV2;
